import { render, staticRenderFns } from "./AddEvaluationGridTemplateDialog.vue?vue&type=template&id=788a0f48"
import script from "./AddEvaluationGridTemplateDialog.vue?vue&type=script&lang=js"
export * from "./AddEvaluationGridTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./AddEvaluationGridTemplateDialog.vue?vue&type=style&index=0&id=788a0f48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports